import {
  Children,
  ReactNode,
  cloneElement,
  forwardRef,
  isValidElement,
  useCallback,
} from 'react';

import { useMuiDialogContext } from './context';

export interface TriggerProps {
  children: ReactNode;
}

export const Trigger = forwardRef((props: TriggerProps, ref) => {
  const { onOpen } = useMuiDialogContext();

  const child = Children.only(props.children);

  if (!isValidElement(child)) {
    throw new Error('child of DialogComposite.Trigger must be an element');
  }
  const childOnClick = child.props.onClick;
  const handleClick = useCallback(() => {
    onOpen();
    if (childOnClick) {
      childOnClick();
    }
  }, [onOpen, childOnClick]);

  return cloneElement(child, {
    ...child.props,
    onClick: handleClick,
    ref,
  });
});

Trigger.displayName = 'DialogComposite.Trigger';

export default Trigger;
